import { Play, Wallet, TrendingUp } from "lucide-react";

/**
 * Driver Status & Earnings card.
 * Wraps the GO/STOP toggle and the wallet earnings summary into a coherent unit.
 */
export const DriverStatusCard = ({
  isAvailable,
  onToggleAvailability,
  walletBalance,
  totalDeliveries,
  onOpenWalletRecharge,
}) => {
  return (
    <>
      {/* GO/STOP big button */}
      <div className="flex justify-center py-4">
        <button
          onClick={onToggleAvailability}
          className={`w-32 h-32 rounded-full border-[8px] transition-all duration-500 flex flex-col items-center justify-center gap-1 shadow-2xl active:scale-95 ${
            isAvailable
              ? "bg-red-600 border-red-900/30 shadow-red-600/30 hover:bg-red-500"
              : "bg-gradient-to-br from-[#D4AF37] to-[#B8962E] border-[#D4AF37]/30 shadow-[#D4AF37]/40 hover:opacity-90"
          }`}
          data-testid="toggle-availability-btn"
        >
          <Play
            size={36}
            fill="currentColor"
            className={`${isAvailable ? "rotate-90 text-white" : "text-[#0F172A]"}`}
          />
          <span
            className={`text-[11px] font-black uppercase tracking-widest ${
              isAvailable ? "text-white" : "text-[#0F172A]"
            }`}
          >
            {isAvailable ? "Stop" : "Partir"}
          </span>
        </button>
      </div>

      {/* Earnings */}
      <div
        className="bg-slate-900 border border-slate-800 rounded-[2.5rem] p-6 relative overflow-hidden group"
        style={{ transform: "translateZ(0)" }}
        data-testid="courier-earnings-card"
      >
        <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:rotate-12 transition-transform pointer-events-none">
          <TrendingUp size={80} />
        </div>
        <p className="text-slate-400 text-[10px] font-black uppercase tracking-[0.2em] mb-2">
          Solde du portefeuille
        </p>
        <div className="flex justify-between items-end relative z-10">
          <div>
            <h2 className="text-4xl font-black italic">
              {walletBalance.toLocaleString("fr-FR")}{" "}
              <span className="text-sm not-italic text-[#D4AF37] uppercase">FCFA</span>
            </h2>
            <p className="text-[10px] text-emerald-400 font-bold mt-1">
              {totalDeliveries} livraisons totales
            </p>
          </div>
          <button
            onClick={onOpenWalletRecharge}
            className="bg-white/10 p-3 rounded-2xl border border-white/10 hover:border-[#D4AF37]/50 hover:scale-105 transition-all"
            title="Recharger mon wallet"
            data-testid="wallet-recharge-btn"
          >
            <Wallet size={20} className="text-[#D4AF37]" />
          </button>
        </div>
      </div>
    </>
  );
};
